import router from '../services/router_service';
import signOutController from '../controllers/signout_controller';

router.on('route:signout', signOutController);
